import { Input, Component, OnInit } from '@angular/core';

@Component({
    selector: 'pager-info',
    template: require('./pager-info.component.html'),
    styles: [require('./pager-info.component.css')]
})
export class PagerInfoComponent implements OnInit {
    @Input() indexStart: number;
    @Input() indexEnd: number;
    @Input() totalCount: number;
    
    ngOnInit(): void {
        
    }

}